<template>
  <footer class="footer" id="footer">
    <div class="container">
      <div class="row ">
        <div>
          <div class="datos">
           <img src="../assets/logo-footer.png" alt="Mega Compañía - Logo" class="logo">
           <div class="rrss">
            <a target="_blank" href="https://ar.linkedin.com/company/ciamega"> <img src="../assets/in.png" alt="Mega Compañía - Logo" class="logo"></a>
             <a target="_blank" href="https://www.youtube.com/channel/UCJIz0KFkNtsea_iY-H2b2cQ"><img src="../assets/yt.png" alt="Mega Compañía - Logo" class="logo"></a>
           </div>
          </div>
        </div>
        <div>
          <div class="datos">
            <h4>BUENOS AIRES</h4>
            <p>San Martín 344, piso 27º</p>
            <p>(C1004AAH)</p>
            <p>Ciudad Autónoma de Buenos Aires</p>
            <p>Tel: <a href="tel:+541128210300">(54 11) 2821-0300</a></p>
          </div>
        </div>
        <div>
          <div class="datos">
            <h4>PLANTA NEUQUEN</h4>
            <p>Ruta Provincial 51, km 85</p>
            <p>(Q8300XAD) Loma La Lata</p>
            <p>Provincia de Neuquén</p>
            <p>Tel: <a href="tel:+542994904400">(54 299) 490-4400</a> </p>
          </div>
        </div>
        <div>
          <div class="datos">
            <h4>PLANTA BAHIA BLANCA</h4>
            <p>Av. del Desarrollo Presidente Frondizi s/n</p>
            <p>(B8000XAU) Puerto Galván</p>
            <p>Provincia de Buenos Aires</p>
            <p>Tel: <a href="te:+542914037650">(54 291) 403-7650</a></p>
          </div>
        </div>
        <div>
          <div class="datos">
            <h4>Línea Emergencias Poliducto</h4>
            <p>Para informar alguna irregularidad o realizar una consulta acerca de nuestro poliducto llamar a nuestra línea gratuita las 24 horas, los 365 días del año: <strong><a href="te:+5408009998050">0-800-999-8050</a></strong></p>
          </div>
        </div>
      </div>
    </div> 
    <div class="container">
      <div class="row disp">
        <p class="pata">2021© Todos los derechos reservados</p>
        <a class="patas" href="https://synapsis.com.ar/"><img src="../assets/syna.png" alt="">Synapsis</a>
      </div>
    </div>  
  </footer>
</template>

<script>

export default {
  name: 'Pie',
  props: ['empresa']
}
</script>

<style scoped lang="sass">
footer 
  background: #eaeaea
  padding: 20px 0
.datos
  text-align: left
  margin: 0 auto 10px
  width: 210px
h4 
  font-size: 14px
  line-height: 20px
  text-transform: uppercase
  color: #004D9E
  font-weight: 700
p 
  font-size: 14px
  line-height: 20px
  color: #000
  margin: 0
a
  color: #000
  text-decoration: none
  &:hover 
    color: #004D9E
.rrss
  display: flex
  padding-top: 20px
  a
    padding: 0 7px
.row
  display: flex
  justify-content: space-between
  padding-top: 20px
  @media(max-width: 800px)
    padding: 10px
  .pata
    text-transform: uppercase
    font-size: 10px
  .patas
    text-transform: uppercase
    font-size: 10px
    display: flex
    align-items: center
    img
      padding-right: 4px
</style>



// WEBPACK FOOTER //
// src/components/Pie.vue